<template>
  <div class="dropdown cursor-pointer" :class="{'displayed':isOpen}" v-click-outside="lostFocus">
    <div @click="toggleOpen" class=" text-right " v-if="title">{{ title }}
      <font-awesome-icon icon="sort"></font-awesome-icon>
    </div>
    <div class="dropdown-content border-t-2 border-classen__primary">
      <div v-if="isOpen" v-for="item in items" @click="selectedCopy=item; isOpen=false"
           class="flex mt-2 w-full filter-item border-b border-classen__secondary">
        <c-checkbox class="mt-auto mb-auto" :mode="'medium'"
                    :selected="item.value===selectedCopy.value"></c-checkbox>
        <label class="text-left">{{ item.text }}</label>
      </div>
    </div>
  </div>
</template>

<script>

import ClickOutside from 'vue-click-outside'
import CustomCheckbox from "../form/CustomCheckbox";
import EventBus from "../../services/EventBus";

export default {
  name: "SortingDropdown",

  props: {
    items: {required: true, type: Array, default: []},
    title: {required: false, type: String},
    selectedItem: {
      required: false,
      type: Object,
      default: function () {
        return {value: 'articleNumber', direction: 'desc', text: 'Article number'}
      }
    },
  },

  components: {
    'c-checkbox': CustomCheckbox
  },

  created() {
    EventBus.listen('close-menus', this.close)
  },

  destroyed() {
    EventBus.destroy('close-menus', this.close)
  },

  data() {
    return {
      isOpen: false,
      selectedCopy: this.selectedItem
    };
  },

  watch: {
    selectedCopy() {
      this.$emit("updateSelected", this.selectedCopy);
    }
  },

  methods: {
    lostFocus() {
      this.isOpen = false;
    },

    toggleOpen() {
      this.isOpen = !this.isOpen;
      EventBus.fire('close-selection');
      EventBus.fire('close-nav');
    },

    close() {
      this.isOpen = false;
    },
  },

  directives: {
    ClickOutside
  }

}
</script>

<style scoped>
.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #FFFFFF;
  width: 100%;
  height: fit-content;
  padding: 12px 16px;
  z-index: 1;
  box-shadow: 0 0 2px 2px rgba(234, 235, 236, 0.71);
}

.displayed .dropdown-content {
  display: block;
}

.filter-item {
  height: 40px;
  line-height: 40px;
}
</style>
